<ng-container *ngTemplateOutlet="minimized ? iconButton : button" />

<ng-template #iconButton>
  @switch (selectCtrl.itemSelector.selected()?.value?.type) {
    @case (MailboxSelectType.All) {
      <rt-icon-button
        [iconName]="'mail-outline'"
        variant="outline"
        (click)="selectCtrl.toggle(true)"
      />
    }
    @case (MailboxSelectType.Personal) {
      <div class="avatar-button" (click)="selectCtrl.toggle(true)">
        <rt-avatar
          context="admin"
          [size]="'small'"
          [type]="currentUser.hasAvatar ? 'image' : 'initials'"
          [imageSrc]="currentUser.photoThumbUrl"
          [initials]="currentUser.initials"
        />
      </div>
    }
    @case (MailboxSelectType.Shared) {
      <rt-icon-button
        [iconName]="'account-group'"
        variant="outline"
        (click)="selectCtrl.toggle(true)"
      />
    }
  }
</ng-template>

<ng-template #button>
  @if (selectCtrl.itemSelector.selected(); as selected) {
    @switch (selected.value.type) {
      @case (MailboxSelectType.All) {
        <rt-button
          [size]="triggerSize"
          [variant]="'outline'"
          [disabled]="selectCtrl.isDisabled()"
          [dropdownOpened]="selectCtrl.isOpen()"
          [dropdownVisible]="true"
          (click)="selectCtrl.toggle(true)"
        >
          <rt-icon [name]="'mail'" />
          <rt-truncate class="inbox-label">{{ selected.label }}</rt-truncate>
        </rt-button>
      }

      @case (MailboxSelectType.Personal) {
        <rt-button
          [size]="triggerSize"
          [variant]="'outline'"
          [disabled]="selectCtrl.isDisabled()"
          [dropdownOpened]="selectCtrl.isOpen()"
          [dropdownVisible]="true"
          (click)="selectCtrl.toggle(true)"
        >
          <rt-avatar
            prefix
            margin-right-small-x
            context="admin"
            [size]="'small-x'"
            [type]="currentUser.hasAvatar ? 'image' : 'initials'"
            [imageSrc]="currentUser.photoThumbUrl"
            [initials]="currentUser.initials"
          />
          <rt-truncate class="inbox-label">{{ selected.label }}</rt-truncate>
        </rt-button>
      }

      @case (MailboxSelectType.Shared) {
        <rt-button
          [size]="triggerSize"
          [variant]="'outline'"
          [disabled]="selectCtrl.isDisabled()"
          [dropdownOpened]="selectCtrl.isOpen()"
          [dropdownVisible]="true"
          (click)="selectCtrl.toggle(true)"
        >
          @if (selected.value.provider?.connectionStatus === 'connected') {
            <rt-icon prefix name="account-group" />
          } @else {
            <rt-icon prefix name="link-off" />
          }

          <rt-truncate class="inbox-label">{{ selected.label }}</rt-truncate>
        </rt-button>
      }

      @case (MailboxSelectType.AutomatedActionAdmin) {
        <rt-button
          [size]="triggerSize"
          [variant]="'outline'"
          [disabled]="selectCtrl.isDisabled()"
          [dropdownOpened]="selectCtrl.isOpen()"
          [dropdownVisible]="true"
          (click)="selectCtrl.toggle(true)"
        >
          @if (selected.value.user) {
            <rt-avatar
              prefix
              margin-right-small-x
              context="admin"
              [size]="'small-x'"
              [type]="selected.value.user.hasAvatar ? 'image' : 'initials'"
              [imageSrc]="selected.value.user.photoThumbUrl"
              [initials]="selected.value.user.initials"
            />
            <rt-truncate class="inbox-label">{{ selected.label }}</rt-truncate>
          } @else {
            <rt-avatar
              prefix
              margin-right-small-x
              type="icon"
              iconName="person"
              context="admin"
              size="small-x"
            />
            <rt-truncate class="inbox-label">{{ selected.label | translate }}</rt-truncate>
          }
        </rt-button>
      }

      @case (MailboxSelectType.AutomatedActionUserPerforming) {
        <rt-button
          [size]="triggerSize"
          [variant]="'outline'"
          [disabled]="selectCtrl.isDisabled()"
          [dropdownOpened]="selectCtrl.isOpen()"
          [dropdownVisible]="true"
          (click)="selectCtrl.toggle(true)"
        >
          <rt-icon prefix name="person" />
          <rt-truncate class="inbox-label">{{ selected.label }}</rt-truncate>
        </rt-button>
      }

      @case (MailboxSelectType.AutomatedActionRecruiter) {
        <rt-button
          [size]="triggerSize"
          [variant]="'outline'"
          [disabled]="selectCtrl.isDisabled()"
          [dropdownOpened]="selectCtrl.isOpen()"
          [dropdownVisible]="true"
          (click)="selectCtrl.toggle(true)"
        >
          <rt-icon prefix name="person-outline" />
          <rt-truncate class="inbox-label">{{ selected.label }}</rt-truncate>
        </rt-button>
      }

      @case (MailboxSelectType.AutomatedActionHiringManager) {
        <rt-button
          [size]="triggerSize"
          [variant]="'outline'"
          [disabled]="selectCtrl.isDisabled()"
          [dropdownOpened]="selectCtrl.isOpen()"
          [dropdownVisible]="true"
          (click)="selectCtrl.toggle(true)"
        >
          <rt-icon prefix name="person-outline" />
          <rt-truncate class="inbox-label">{{ selected.label }}</rt-truncate>
        </rt-button>
      }
    }
  } @else {
    <rt-button
      [size]="triggerSize"
      [variant]="'outline'"
      [disabled]="selectCtrl.isDisabled()"
      [dropdownOpened]="selectCtrl.isOpen()"
      [dropdownVisible]="true"
      (click)="selectCtrl.toggle(true)"
    >
      <rt-truncate class="inbox-label">{{ selectCtrl.itemSelector.selected()?.label }}</rt-truncate>
    </rt-button>
  }
</ng-template>
